/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const AddSubLimitPage = lazyLoad(
  () => import('./index'),
  module => module.AddSubLimitPage,
);
